export function adminCurrencyFormatter(value?: number) {
  if (value) {
    return `Rp${value.toLocaleString('en-US', { minimumFractionDigits: 2 })}`;
  } else {
    return 'Rp0';
  }
}

export function buyerCurrencyFormatter(value?: number) {
  if (value) {
    return `Rp${value.toLocaleString('id-ID')}`;
  } else {
    return 'Rp0';
  }
}

export function numberSeparator(value: number | string) {
  if (value) {
    return `${value.toLocaleString('id-ID')}`;
  } else {
    return `-`;
  }
}

export function numberWithSeparator(val: number | string) {
  const parts = val.toString().split('.');
  const numberPart = parts[0];
  const decimalPart = parts[1];
  const thousands = /\B(?=(\d{3})+(?!\d))/g;
  const decimalResult = decimalPart ? ',' + decimalPart : '';
  return numberPart.replace(thousands, '.') + decimalResult;
}

export function convertToFloat(value: string): number {
  if (!value || typeof value !== 'string') {
    return NaN;
  }

  const trimmedValue = value.trim();
  if (trimmedValue === '') {
    return NaN;
  }

  const hasComma = trimmedValue.includes(',');
  const hasDot = trimmedValue.includes('.');

  if (hasComma) {
    const parts = trimmedValue.split(',');
    if (parts.length > 2) {
      return NaN;
    }

    const integerPart = parts[0].replace(/\./g, '');
    const decimalPart = parts[1] || '';
    const sanitizedValue = `${integerPart}.${decimalPart}`;
    const floatValue = parseFloat(sanitizedValue);
    return Number.isFinite(floatValue) ? floatValue : NaN;
  }

  if (hasDot) {
    const parts = trimmedValue.split('.');
    const lastPart = parts[parts.length - 1];
    const digitsAfterLastDot = lastPart.length;

    if (digitsAfterLastDot <= 2 && parts.length === 2) {
      const floatValue = parseFloat(trimmedValue);
      return Number.isFinite(floatValue) ? floatValue : NaN;
    }

    const integerPart = trimmedValue.replace(/\./g, '');
    const floatValue = parseFloat(integerPart);
    return Number.isFinite(floatValue) ? floatValue : NaN;
  }

  const floatValue = parseFloat(trimmedValue);
  return Number.isFinite(floatValue) ? floatValue : NaN;
}

export interface ValidateQuantityInputResult {
  isValid: boolean;
  errorMessage?: string;
}

export function validateQuantityInput(
  value: number,
  maxUi: number
): ValidateQuantityInputResult {
  if (!Number.isFinite(value)) {
    return {
      isValid: false,
      errorMessage: 'Jumlah tidak valid. Silakan masukkan angka yang benar',
    };
  }

  if (value < 0) {
    return {
      isValid: false,
      errorMessage: 'Jumlah tidak valid. Silakan masukkan angka yang benar',
    };
  }

  const MAX_SAFE_VALUE = Number.MAX_SAFE_INTEGER / 1000;
  if (value > MAX_SAFE_VALUE) {
    return {
      isValid: false,
      errorMessage: 'Jumlah terlalu besar, melebihi batas maksimum stok',
    };
  }

  if (value > maxUi) {
    return {
      isValid: false,
      errorMessage: 'Jumlah terlalu besar, melebihi batas maksimum stok',
    };
  }

  return { isValid: true };
}
